import { DateFormatter } from '@repo/toolkit/date'

import { LanguageEnum } from '../../types/enums/languages/language.enum'
import { DiplomaEnum } from '../../types/enums/staff-application/diploma.enum'
import { EvalutationEnum } from '../../types/enums/staff-application/evalutation.enum'
import { StaffApplicationStatusEnum } from '../../types/enums/staff-application/staff-application-status.enum'
import { StaffApplicationType } from '../../types/enums/staff-application/staff-application-type.enum'
import { StaffApplicationFilters } from '../../types/models/staff-application/staff-application'

export const transformStaffApplicationFiltersToUrl = (
  filters?: StaffApplicationFilters
): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()
  if (filters.diplomas && filters.diplomas.length)
    searchParams.append('diplomas', filters.diplomas.join(','))
  if (filters.evaluations && filters.evaluations.length)
    searchParams.append('evaluations', filters.evaluations.join(','))
  if (filters.fromDate) searchParams.append('from_date', filters.fromDate)
  if (filters.toDate) searchParams.append('to_date', filters.toDate)
  if (filters.languages && filters.languages.length)
    searchParams.append('languages', filters.languages.join(','))
  if (filters.pcrId) searchParams.append('pcr_id', filters.pcrId.toString())
  if (filters.periods && filters.periods.length)
    searchParams.append('periods', filters.periods.join(','))
  if (filters.showWithdrawApplications)
    searchParams.append('show_withdraw_applications', filters.showWithdrawApplications.toString())
  if (filters.statuses && filters.statuses.length)
    searchParams.append('statuses', filters.statuses.join(','))
  if (filters.excludedStatuses && filters.excludedStatuses.length)
    searchParams.append('excluded_statuses', filters.excludedStatuses.join(','))
  if (filters.types && filters.types.length) searchParams.append('types', filters.types.join(','))
  if (filters.similarApplications)
    searchParams.append('similar_applications', filters.similarApplications.toString())

  return searchParams.toString()
}

export const transformUrlToStaffApplicationFilters = (
  searchParams: URLSearchParams
): StaffApplicationFilters => {
  const filters: StaffApplicationFilters = {}

  const diplomas = searchParams.get('diplomas')
  if (diplomas && diplomas.length) filters.diplomas = diplomas.split(',') as DiplomaEnum[]
  const evaluations = searchParams.get('evaluations')
  if (evaluations && evaluations.length)
    filters.evaluations = evaluations.split(',') as EvalutationEnum[]

  const fromDate = DateFormatter.checkDateFormat(searchParams.get('from_date'))
  const toDate = DateFormatter.checkDateFormat(searchParams.get('to_date'))

  if (fromDate) filters.fromDate = fromDate
  if (toDate) filters.toDate = toDate

  const languages = searchParams.get('languages')
  if (languages && languages.length) filters.languages = languages.split(',') as LanguageEnum[]

  const pcrId = searchParams.get('pcr_id')
  if (pcrId) filters.pcrId = +pcrId

  const periods = searchParams.get('periods')
  if (periods && periods.length) filters.periods = periods.split(',').map(Number)

  const showWithdrawApplications = searchParams.get('show_withdraw_applications')
  if (showWithdrawApplications)
    filters.showWithdrawApplications = showWithdrawApplications === 'true'

  const statuses = searchParams.get('statuses')
  if (statuses && statuses.length)
    filters.statuses = statuses.split(',') as StaffApplicationStatusEnum[]

  const excludedStatuses = searchParams.get('excluded_statuses')
  if (excludedStatuses && excludedStatuses.length)
    filters.excludedStatuses = excludedStatuses.split(',') as StaffApplicationStatusEnum[]

  const types = searchParams.get('types')
  if (types && types.length) filters.types = types.split(',') as StaffApplicationType[]

  const similarApplications = searchParams.get('similar_applications')
  if (similarApplications) filters.similarApplications = similarApplications === 'true'

  return filters
}
